import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { Handle, Position } from '@xyflow/react';
import { G_GRAPH__handle_edges_amount } from './G_GRAPH__handle_edges_amount';
import { HOOK__handle_is_connectable_base } from './HOOK__handle_is_connectable_base';

interface PROPS {
  field: FIELD__base;
}

export function G_GRAPH__handle_right({ field }: PROPS) {
  /*
   * STORE
   */

  const { g_graph__new_edge_field_position, g_graph__new_edge_field, g_general__ui_disabled } = use_slice_ui([
    'g_graph__new_edge_field_position',
    'g_graph__new_edge_field',
    'g_general__ui_disabled',
  ]);

  let is_connectable_base = HOOK__handle_is_connectable_base(field);
  let is_connectable = get_is_connectable();

  /*
   * METHODS
   */

  function get_is_connectable() {
    if (g_graph__new_edge_field_position == Position.Right) return false;

    return is_connectable_base;
  }

  function get_class_name() {
    if (g_graph__new_edge_field.meta.field_id == field.meta.field_id && g_graph__new_edge_field_position == Position.Left) return '!opacity-100'; //this handle selected

    return is_connectable ? '!opacity-100' : '!opacity-0';
  }

  /*
   * HTML
   */

  if (field.meta.node_type == ENUM__invocation_type.GRID2D__VIEW) return null;

  return (
    <Handle
      type="source"
      position={Position.Right}
      id={`${field.meta.field_id}_${Position.Right}`}
      isConnectable={get_is_connectable()}
      className={`
        !right-[-0.5rem] 
        !w-3 
        !h-4 
        !bg-white 
        ${get_class_name()}
        border-none
        hover:!opacity-100 
        !rounded-l-none 
        !rounded-r-[4px]
        !m-0
        !p-0
        ${g_general__ui_disabled && '!pointer-events-none'}
      `}
    >
      <G_GRAPH__handle_edges_amount {...{ field }} edges_to={false} />
    </Handle>
  );
}
